/* script */
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'ShortenedLink',

    props: {
        url: {
            type: String,
            default: ''
        },

        placeholder: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            base: null,
            code: null,
        };
    },

    computed: {
        visible() {
            return (this.base && this.code) || this.placeholder?.length;
        }
    },

    watch: {
        url(newUrl) {
            this.computeUrl(newUrl);
        }
    },

    created() {
        this.computeUrl(this.url);
    },

    methods: {
        computeUrl(newUrl) {
            if (!newUrl) {
                return;
            }

            try {
                const url = new URL(newUrl);
                const { origin, pathname } = url;
                const splitPath = pathname.split('/');

                let code = splitPath.pop();
                // handles the trailing / case.
                if (!code.length && splitPath.length) {
                    code = splitPath.pop();
                }
                // put back everything that wasn't popped.
                const base = `${origin}${splitPath.join('/')}`;

                this.base = base;
                this.code = code;
            } catch (e) {
                console.error('Invalid URL:', this.url, e);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('span',{staticClass:"shortened-link"},[(_vm.placeholder && !_vm.url)?[_c('span',{staticClass:"base"},[_vm._v(_vm._s(_vm.placeholder))])]:[_c('span',{staticClass:"base"},[_vm._v(_vm._s(_vm.base))]),_c('span',{staticClass:"sep"},[_vm._v("/")]),_c('span',{staticClass:"code"},[_vm._v(_vm._s(_vm.code))])]],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ShortenedLink.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__